import { Container, Grid, Typography } from '@mui/material'
import { AboutCard, ExpressPricesCard, PricesCard, PrivacyPolicyCard, TermsAndConditionsCard, PhoneNumberCard } from './components'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from 'lodash'
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'api/adminSlice'
import { useEffect, useState } from 'react'

export default function Settings() {
  const { t } = useTranslation()

  const [settings, setSettings] = useState(null)

  const handleChange = ({ target: { name, value } }) => {
    setSettings(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const { data: settingsData, isLoading, refetch } = useGetSettingsQuery()
  const [updateSettings, { isLoading: updateLoading, isSuccess, error }] = useUpdateSettingsMutation()

  useEffect(() => {
    if (!!settingsData) {
      setSettings(cloneDeep(settingsData))
    }
  }, [settingsData])

  const [card, setCard] = useState(null)

  const updateSettingsHandler = async (payload, type) => {
    setCard(type)
    await updateSettings(payload)
    refetch()
    setTimeout(() => {
      setCard(null)
    }, 3000);
  }

  return (
    <Container sx={{ my: 30 }}>
      <Grid container spacing={20}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant='h5'>{t("Article pages")}</Typography>
        </Grid>
        <Grid item md={4} sm={12} xs={12}>
          <TermsAndConditionsCard />
        </Grid>
        <Grid item md={4} sm={12} xs={12}>
          <PrivacyPolicyCard />
        </Grid>
        <Grid item md={4} sm={12} xs={12}>
          <AboutCard />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <PricesCard
            settings={settings}
            handleChange={handleChange}
            onConfirm={(payload) => updateSettingsHandler(payload, "PRICES")}
            error={card === "PRICES" && error}
            isSuccess={card === "PRICES" && isSuccess}
            loading={card === "PRICES" && updateLoading}
          />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <ExpressPricesCard
            settings={settings}
            onConfirm={(payload) => updateSettingsHandler(payload, "EXPRESS")}
            error={card === "EXPRESS" && error}
            isSuccess={card === "EXPRESS" && isSuccess}
            loading={card === "EXPRESS" && updateLoading}
          />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <PhoneNumberCard
            settings={settings}
            handleChange={handleChange}
            onConfirm={(payload) => updateSettingsHandler(payload, "PHONE_NUMBER")}
            error={card === "PHONE_NUMBER" && error}
            isSuccess={card === "PHONE_NUMBER" && isSuccess}
            loading={card === "PHONE_NUMBER" && updateLoading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
